document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.cart-drawer-close').addEventListener('click', function() {
    handleClickOutside();
  });
  
  document.querySelector('.site-header__icon.site-header__cart').addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelector('.main-cart-drawer').classList.add('open-drawer');
    document.body.classList.add('open-cartdrawer');
    openCartDrawer();
  });

  document.querySelectorAll('.item-quantity-wrapper .quantity__input').forEach(function(input) {
  input.addEventListener('click', function(event) {
        event.preventDefault();
        input.blur();
    });
  });
});

    // Function to handle outside clicks
function handleClickOutside() {
    document.querySelector('.main-cart-drawer').classList.remove('open-drawer');
    document.body.classList.remove('open-cartdrawer');
    document.body.removeEventListener('click', onBodyClick);
}

// Function to handle body clicks
function onBodyClick(event) {
    if (!event.target.closest('.main-cart-drawer')) {
        handleClickOutside();
    }
}

function openCartDrawer() {
    document.querySelector('.main-cart-drawer').classList.add('open-drawer');
    document.body.classList.add('open-cartdrawer');

    // Add event listener for body click to handle closing the drawer
    setTimeout(() => {
        document.body.addEventListener('click', onBodyClick);
    }, 0);
}

// var mainCartDrawer = document.querySelector('body');
// var shop_currency = mainCartDrawer.getAttribute('data-currency');
// var currency = shop_currency.split('{{')[0];

document.addEventListener('click', function(e) {
  if (e.target.closest('.product-form__cart-submit')) {
    e.preventDefault();
      var productMeta = e.target.closest('.product-single__meta');
      var variantId = productMeta.querySelector('select[name="id"]').value;
      var productQty = productMeta.querySelector('.product-form__input--quantity').value;
      // Add product to cart using AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: productQty
        })
      })
      .then(response => response.json())
      .then(data => {
        // Update the cart drawer
        finalupdateCart();
        setTimeout(function() {
          openCartDrawer();
        document.querySelector('.main-cart-drawer .filled-cart').classList.remove('hide');
        document.querySelector('.main-cart-drawer .empty-page-content').classList.add('hide');
        },200);
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });
  }
});

  function handleQuantityButtonClick(element) {
    // Find the input field and other necessary elements relative to the clicked button
    var input = element.closest('.cart-item-loop').querySelector('.quantity__input');
    var currentValue = parseInt(input.value);
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var price = parseFloat(element.closest('.cart-item-loop').getAttribute('data-price'));

    if (element.classList.contains('plus')) {
        input.value = currentValue + 1;
    } 
    else if (element.classList.contains('minus')) {
        var newValue = currentValue - 1;
        input.value = Math.max(newValue, min);
        if (newValue <= 0) {
           updateCart(input.dataset.quantityVariantId, 0);
            return;
        }
    }

    updateCart(input.dataset.quantityVariantId, input.value);
    }

function updateCart(variantId, quantity) {
    fetch('/cart/change?id='+variantId+'&quantity='+quantity, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(response => response.text())
    .then(data => {
      //console.log("data",data);
      finalupdateCart();
    })
    .catch(error => {
        console.error('Error updating cart', error);
    });
}

function finalupdateCart() {
   fetch('/cart')
                .then(response => response.text())
                .then(data => {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(data, 'text/html');
                    console.log("doc",doc);
                    var newContent = doc.querySelector('.data-get-cart').innerHTML;
                            console.log(newContent);
                    document.querySelector('.drawer-items-inner').innerHTML = newContent;
                  var getsubtotal = doc.querySelector('.data-get-cart').getAttribute('data-subtotal');
                  document.querySelector('.cart-total').innerHTML = getsubtotal;
                  var getqty = parseInt(doc.querySelector('.data-get-cart').getAttribute('data-quantity'));
                  document.querySelector('.site-header__cart-count span[data-cart-count]').textContent = getqty;
                  console.log(getqty);
                  if (getqty > 0) {
                    document.querySelector('.main-cart-drawer').classList.add('hascartitem');
                    document.querySelector('.main-cart-drawer').classList.remove('emptycartitem');
                    document.querySelector('.site-header__cart-count').classList.remove("hide");
                    document.querySelector('.cart-drawer-text').classList.remove("hide");
                  }
                  else {
                    
                    document.querySelector('.main-cart-drawer').classList.remove('hascartitem');
                    document.querySelector('.main-cart-drawer').classList.add('emptycartitem');
                    document.querySelector('.site-header__cart-count').classList.add("hide");
                    document.querySelector('.cart-drawer-text').classList.add("hide");
                    document.querySelector(".cart-drawer-close").click();
                    console.log('sss');
                  }
                })
                .catch(error => console.error('Error:', error));
}

function removeItemFromCart(variantId) {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 0
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Item removed from cart', data);
        updateSubtotal(data);
        // Optionally update the cart UI here
        var itemWrapper = document.querySelector(`.quantity__input[data-quantity-variant-id="${variantId}"]`).closest('.cart-item-loop');
        itemWrapper.remove();
      document.querySelector('.main-cart-drawer').classList.remove('hascartitem');
                    document.querySelector('.main-cart-drawer').classList.add('emptycartitem');
    })
    .catch(error => {
        console.error('Error removing item from cart', error);
    });
}

function updateSubtotal(cartData) {
    var subtotalElement = document.querySelector('.cart-total');
    if (subtotalElement) {
        subtotalElement.textContent = formatMoney(cartData.total_price);
    }
}

function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || shop_currency;
    function defaultOption(opt, def) {
        return (typeof opt === 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return '0';
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}